import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import HeroExtremeSection from "./sections/HeroExtremeSection";
import CommercialWhyChooseUs from "./sections/CommercialWhyChooseUs";
import Services from "./sections/Services";
import BarrasDeAccess from "./sections/BarrasDeAccess";
import CablingStandards from "./sections/CablingStandards";
import GetStarted from "./sections/GetStarted";
import ProfessionalServicesGrid from "./sections/ProfessionalServicesGrid";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Services />
      <HeroExtremeSection />
      <CommercialWhyChooseUs />
      <ProfessionalServicesGrid />
      <BarrasDeAccess />
      <CablingStandards />
      <GetStarted />
      <Footer />
    </div>;
}